import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db, googleProvider } from '../config/firebase';

export const registerUser = async (email, password, username) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;
  
  // Create user document in Firestore
  await setDoc(doc(db, 'users', user.uid), {
    userId: user.uid,
    username: username,
    email: email,
    createdAt: new Date(),
    stats: {
      wins: 0,
      losses: 0,
      draws: 0,
      totalGames: 0
    }
  });
  
  return user;
};

export const loginUser = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
};

export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const user = result.user;
  
  // Check if user document exists
  const userDoc = await getDoc(doc(db, 'users', user.uid));
  
  if (!userDoc.exists()) {
    // Create user document for new Google users
    await setDoc(doc(db, 'users', user.uid), {
      userId: user.uid,
      username: user.displayName || user.email.split('@')[0],
      email: user.email,
      photoURL: user.photoURL || null,
      createdAt: new Date(),
      stats: {
        wins: 0,
        losses: 0,
        draws: 0,
        totalGames: 0
      }
    });
  }
  
  return user;
};

export const logoutUser = async () => {
  await signOut(auth);
};

export const getUserData = async (userId) => {
  const userDoc = await getDoc(doc(db, 'users', userId));
  return userDoc.exists() ? userDoc.data() : null;
};

export const subscribeToAuthChanges = (callback) => {
  return onAuthStateChanged(auth, callback);
};
